import chargingSpots from "./charging-spots.json";

export default {
  chargingSpots,
};
